import type { FundingApplicationSchemas } from "api-types";
import { axiosClient } from "auth-sdk";

import { FUNDING_APPLICATION_CONFIGURATION_API } from "../../components/constants";

export const getFundingApplicationStagesQueryOptions = (customerDomain: string) => {
  const url = FUNDING_APPLICATION_CONFIGURATION_API.replace(":customerSlug", customerDomain);

  return {
    queryKey: [url],
    queryFn: () => axiosClient.get<FundingApplicationSchemas.CustomerFundingApplicationStagesScreen>(url),
    select: ({
      data,
    }: {
      data: FundingApplicationSchemas.CustomerFundingApplicationStagesScreen;
    }): FundingApplicationSchemas.CustomerFundingApplicationStagesScreen => data,
    refetchOnMount: true,
  };
};
